
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Qu'est-ce qu'un blog ? Tout savoir sur la création d'un blog",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu'est un blog, ses fonctionnalités et conseils essentiels pour sa création et gestion. Créez maintenant votre blog efficacement.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Qu'est-ce qu'un blog ? Tout savoir sur la création d'un blog",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez ce qu'est un blog, ses fonctionnalités et conseils essentiels pour sa création et gestion. Créez maintenant votre blog efficacement.",
        },
      ],
    };
  },
};
